import { ListItemLabel } from "baseui/list";
import { BacnetObjectMappingConfiguration, useGetMappingsFromObjectIdQuery } from "../../../../services/mapping/bacnet";
import { SpecialEventCalendarReferencePeriod } from "../../../../services/schedulers/types";
import { TScheduler } from "../types";
import { HierarchyObjectNavigation } from "../../../../components/HierarchyNavigation";
import { useGetObjectByIdQuery } from "../../../../services/objects";
import { LoadingView } from "../../../../components";
import { useGetBacnetObjectMappingsByObject } from "../../../../hooks/useGetBacnetMappings";
import { ListPanel } from "../../Calendar/ListPanel";
import { ICalendar } from "../../Calendar";
import { themedUseStyletron } from "../../../../theme/customTheme";
import { hasEntries } from "../../Calendar/utils";
import { useMemo } from "react";
import { LabelMedium } from "baseui/typography";
import { FormattedMessage, useIntl } from "react-intl";
import { ValueDisplayWithLabel } from "../../../components/ValueDisplay";
import { HorizontalStackPanel, VerticalStackPanel } from "../../../../components/Layout/StackPanel";


export const CalendarRefListItem = (props: { eventPriority: number, period: SpecialEventCalendarReferencePeriod, app: TScheduler }) => {
  const { period, app, eventPriority } = props;

  // we already know it
  if (period.twinId && period.twinResourceGroupId)
    return (<CalendarRefListRealObject eventPriority={eventPriority} app={app} objectId={period.twinId} resourceGroupId={period.twinResourceGroupId} period={period}   ></CalendarRefListRealObject>)

  return <CalendarReferenceBacnetObject eventPriority={eventPriority} app={app} period={period} ></CalendarReferenceBacnetObject>
}

const CalendarReferenceBacnetObject = (props: { app: TScheduler, eventPriority: number, period: SpecialEventCalendarReferencePeriod, }) => {
  const { app, eventPriority, period } = props;
  // 1st we need to get a mapping from our app to know the edge device
  const { data: myMappings, isSuccess, isLoading, error } = useGetMappingsFromObjectIdQuery(app.id);

  const firstMapping = (myMappings && myMappings.length > 0) ? myMappings[0] : undefined;
  return (
    <LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} error={error}>
      {firstMapping ?
        <CalendarRefListItemRootMapping eventPriority={eventPriority} app={app} period={period} rootMapping={firstMapping}></CalendarRefListItemRootMapping>
        :
        <ListItemLabel>Calendar: {JSON.stringify(period)}</ListItemLabel>
      }
    </LoadingView>
  )
}

const CalendarRefListItemRootMapping = (props: { eventPriority: number, period: SpecialEventCalendarReferencePeriod, app: TScheduler, rootMapping: BacnetObjectMappingConfiguration }) => {
  const { period, app, rootMapping, eventPriority } = props;
  const { objects: calendarMapping, isSuccess, isLoading, error } = useGetBacnetObjectMappingsByObject(rootMapping.deviceId, rootMapping.bACnetDeviceId, period.type, period.instanceId)

  const foundCalendarMapping = calendarMapping && calendarMapping?.length > 0 ? calendarMapping[0] : undefined

  return (
    <LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} error={error}>
      {foundCalendarMapping ?
        <CalendarRefListRealObject eventPriority={eventPriority} app={app} period={period} objectId={foundCalendarMapping.objectId} resourceGroupId={foundCalendarMapping.resourceGroupId}></CalendarRefListRealObject>
        :
        <ListItemLabel>Calendar: {JSON.stringify(period)}</ListItemLabel>
      }
    </LoadingView>)
}

const CalendarRefListRealObject = (props: { eventPriority: number, period: SpecialEventCalendarReferencePeriod, app: TScheduler, objectId: string, resourceGroupId: string }) => {
  const { period, app, eventPriority } = props;
  const { data: calendar, isSuccess, isLoading, error } = useGetObjectByIdQuery({ id: props.objectId, resourceGroupId: props.resourceGroupId })



  return (
    <LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} error={error}>
      {calendar ?
        <ListItemLabel
          overrides={{
            LabelContent: {
              style: ({ $theme }) => ({
                fontSize: $theme.typography.ParagraphSmall.fontSize
              })
            }
          }} description={<VerticalStackPanel>
            {`Priority: ${eventPriority}`}
            <SmallCalendarStatusPanel {...calendar}></SmallCalendarStatusPanel>
          </VerticalStackPanel>}>
          <HierarchyObjectNavigation current={calendar.name} skip={1} currentAsLink currentDescription={calendar.description} showDescription objectId={calendar.id} resourceGroupId={calendar.resourceGroupId} ></HierarchyObjectNavigation>
        </ListItemLabel>
        :
        <ListItemLabel>Calendar: {JSON.stringify(period)}</ListItemLabel>
      }
    </LoadingView>
  )
}

const SmallCalendarStatusPanel: React.FC<ICalendar> = (props) => {
  const [css, theme] = themedUseStyletron();
  const fg = props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off;
  const noEntries = useMemo(() => !hasEntries(props), [props]);
  const intl = useIntl();


  return (
    <>
      {noEntries ?
        <LabelMedium className={css({ color: theme.colors.warning600 })}><FormattedMessage id='Calendar.noEntries' defaultMessage={'Empty'}></FormattedMessage></LabelMedium>
        :
        <ValueDisplayWithLabel color={fg} label={intl.formatMessage({ id: "Calendar.Current", defaultMessage: "currently" })} small value={props.isOn} dimension=""></ValueDisplayWithLabel>
      }
    </>
  );
};

export default SmallCalendarStatusPanel;
